/* eslint-disable max-len */

import React, { useEffect, useState } from "react";
import { HashRouter, Switch, Route, Redirect } from "react-router-dom";

// HOOKS
import { useQlik } from "../context/Qlik";
import { useFilterBar } from "../context/FilterBar";
import { useLeftBar } from "../context/LeftBar";
import { useConfig } from "../context/Config";

// PAGES
import Overview from "./Overview/Overview";
import Pilares from "./Pilares/Pilares";
import Details from "./Details/Details";

// COMPONENTS
import LeftSideMenu from "../components/LeftSideMenu/LeftSideMenu";
import AppLoader from "../components/AppLoader/AppLoader";
import FilterMenu from "../components/FilterMenuNative/FilterMenu";
import Header from "../components/Header/Header";

// ASSETS
// import logo from '../assets/logo.png';
import "../style.scss";
import Msl from "./Msl/Msl";
import PageMobileModal from "./Overview/PageMobile";
import { MS } from "./MS";
import { PendingActions } from "./PendingActions";
import { TableDataPending } from "./MS/Components/TableDataPending";

function Layout() {
  const { qlik, qlikConfig, setActualApp } = useQlik();
  const { filterBarOpened } = useFilterBar();
  const { leftBarOpened } = useLeftBar();
  const { config } = useConfig();
  const [app, setApp] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (qlik) {
      setIsLoading(false);
      const qvfId = process.env.REACT_APP_QVF_ID;
      const tempApp = qlik.openApp(qvfId, qlikConfig);
      window.app = tempApp;
      setApp(tempApp);
      setActualApp(tempApp);
    }
  }, [qlik, qlikConfig, setActualApp]);

  useEffect(() => {
    if (qlik) setTimeout(qlik.resize, 500);
  }, [qlik]);

  return isLoading ? (
    <AppLoader />
  ) : (
    <div
      style={{ left: leftBarOpened && "224px" }}
      className={filterBarOpened ? "appWrapper is-right-opened" : "appWrapper"}
    >
      <div id="expandedWrapper" />
      <HashRouter>
        <LeftSideMenu app={app} config={config} />
        <Header />
        <FilterMenu
          app={app}
          filters={config?.app?.filters || {}}
          config={config}
        />
        <Switch>
          <Route exact path="/">
            <Redirect to="/overview" />
          </Route>

          <Route
            path="/overview"
            exact
            render={() => <Overview app={app} config={config} />}
          />

          <Route
            path="/overview/pilares"
            exact
            render={() => <PageMobileModal app={app} config={config} />}
          />

          <Route
            path="/pilares"
            exact
            render={() => <Pilares app={app} config={config} />}
          />

          <Route
            path="/msl"
            exact
            render={() => <Msl app={app} config={config} />}
          />

          <Route
            path="/details"
            exact
            render={() => <Details app={app} config={config} />}
          />

          {/* <Route path="/ims" exact render={() => <MS />} />

          <Route
            path="/pending-actions"
            exact
            render={() => <PendingActions />}
          /> */}

          {/* <Route
						path="/strategic-products"
						exact
						render={() => (
							<StrategicProducts app={app} config={config} />
						)}
					/> */}
        </Switch>
      </HashRouter>
    </div>
  );
}

export default Layout;
